/*
====================================================================
registrationSession.js

Carries the Client ID from the registration form to the next form the
patient opens, so they do not have to type a number they were given
thirty seconds ago.

sessionStorage, NOT localStorage
--------------------------------
Reception hands one tablet to one patient at a time. sessionStorage is
scoped to the tab and cleared when it closes, so the ID does not
outlive the visit. localStorage would persist across patients, and the
failure mode there is a consent form filed against the previous
person — the worst kind of bug this system can have.

IT PRE-FILLS, IT DOES NOT AUTO-SUBMIT
-------------------------------------
The Client ID gate is still shown, with the field already filled in.
The patient taps Continue and sees their own name before the form
opens. Skipping the gate entirely would save one tap and remove the
only moment where a mix-up is visible before it is recorded.
====================================================================
*/

const KEY = "qrforms.registration";

// Anything older than this is treated as a previous visit.
const MAX_AGE_MS = 2 * 60 * 60 * 1000;   // 2 hours


export function rememberRegistration({ clientId, name, email, token }) {
    try {
        sessionStorage.setItem(KEY, JSON.stringify({
            clientId: String(clientId || ""),
            name: name || "",
            email: email || "",
            token: token || "",
            at: Date.now()
        }));
    } catch (e) {
        // private browsing, storage disabled — the gate just starts empty
    }
}


/*
  `token` scopes it to the QR code it was created under: a tablet that
  somehow carries a session from another clinic should not pre-fill an
  ID that clinic cannot resolve anyway.
*/
export function recallRegistration(token) {
    try {
        const raw = sessionStorage.getItem(KEY);
        if (!raw) return null;

        const data = JSON.parse(raw);

        if (!data.clientId) return null;
        if (Date.now() - (data.at || 0) > MAX_AGE_MS) return null;
        if (token && data.token && data.token !== token) return null;

        return data;
    } catch (e) {
        return null;
    }
}


export function forgetRegistration() {
    try {
        sessionStorage.removeItem(KEY);
    } catch (e) { /* nothing to do */ }
}


export default { rememberRegistration, recallRegistration, forgetRegistration };